import React from 'react';

const Notification = ({ message, onClose }) => {
  return (
    <>
    <div
      className="sticky top-15  text-white p-4 rounded shadow-lg items-center z-50 hidden md:flex"
      style={{ backgroundColor: '#31ab53', width: '30%', zIndex: 9999 ,marginLeft: '70%'}} // Custom background color and width
      role="alert"
    >
      <span className="flex-grow">{message}</span> {/* Allows the text to take up remaining space */}
      <button
        className="bg-red-500 rounded-md"
        style={{ width: '10%' }} // Custom width to make it 10% of the div
        onClick={onClose}
        aria-label="Close notification"
      >
        <span> X </span>
      </button>
    </div>
    {/* Notification for mobile screens (width 90%) */}
    <div
        className="sticky top-15 right-2 text-white p-4 rounded shadow-lg flex items-center z-50 md:hidden"
        style={{ backgroundColor: '#31ab53', width: '100%', zIndex: 9999  }} // Custom background color
        role="alert"
      >
        <span className="flex-grow">{message}</span>
        <button
        className="bg-red-500 rounded-md"
        style={{ width: '10%' }} // Custom width to make it 10% of the div
        onClick={onClose}
        aria-label="Close notification"
      >
        <span> X </span>
      </button>
      </div>
    </>
  );
  
};

export default Notification;
